import { spacer8, spacer20 } from '@spotify-internal/encore-foundation';
import styled, { css } from 'styled-components';
import { defaultTheme } from "../../styles";
import { Type } from "../Type";
export var Title = styled(Type.h1).attrs({
  variant: 'cello',
  weight: 'black'
}).withConfig({
  displayName: "Title",
  componentId: "i526nw-0"
})(["padding-block-end:", ";padding-inline-start:", ";padding-inline-end:", ";", ";"], spacer8, spacer20, spacer20, function (props) {
  return props.hasBorder && css(["border-block-end:1px solid var(--decorative-subdued,", ");"], defaultTheme[props.colorSet].decorative.subdued);
});